module.exports = __webpack_public_path__ + "static/media/cr.0446160e.svg";